import React from "react";
import PropTypes from "prop-types";
import Autosuggest from 'react-autosuggest';

import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from '@material-ui/core/CircularProgress';

import withStyles from "@material-ui/core/styles/withStyles";

// core components
import CustomInput from '../../CustomInput/CustomInput.jsx'
import FacetChip from "./FacetChip";


const styles = () => ({
    // ...tooltipsStyle,
    input: {width: '95%'},
    progress: {
        width: '20px',
        color: '#00bcd4 !important'
    }
})

const autoCompleteStyles = {
    container: {position: 'relative'},
    suggestionsContainer: {display: 'none'},
    suggestionsContainerOpen: {
        display: 'block',
        backgroundColor: '#fff',
        zIndex: 2
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    suggestion: {
        cursor: 'pointer',
        padding: '1px'
    },
    suggestionHighlighted: {backgroundColor: 'transparent'}

};

class FacetAutosuggest extends React.Component {
    render() {
        const { props, classes } = this.props,
            { facet, uiState, suggestions, handleFacetClick, addTag, handleOnChange, otherProps } = props;

        const progressBar = suggestions.isFetching ?
            <CircularProgress size="30" style={{ color: '#00bcd4 !important' }} color="info" className={classes.progress} /> 
            : <span />;

        const noData = otherProps.value && otherProps.value.length > 2 && !suggestions.isFetching && suggestions[facet]
            && suggestions[facet].length === 0 ? <div>{`no ${facet} with '${otherProps.value}'`}</div> : null;

        const suggestionArray = suggestions.isFetching ? [] : suggestions[facet] || [];

        const renderSuggestionsContainer = ({ containerProps, children, query }) => (
            <div {...containerProps}>{children}</div>
        );

        return <Autosuggest
            ref={otherProps.ref}
            suggestions={suggestionArray}
            focusInputOnSuggestionClick={false}  // setting to false per GitHub issue https://github.com/moroshko/react-autosuggest/issues/613
            shouldRenderSuggestions={(value) => value && value.trim().length > 0}
            getSuggestionValue={(suggestion) => suggestion.name}
            renderSuggestion={
                (suggestion, i) => {
                    const className = "react-tagsinput-tag info",
                        tag = `${suggestion.name}||${suggestion.count}||${suggestion.code.toUpperCase()}`,
                        getTagDisplayValue = p => p,
                        onClick = e => handleFacetClick(e, facet, tag),
                        onRemove = p => p;

                    let split = getTagDisplayValue(tag).split('||'),
                        key = split[0],
                        isSelected = uiState && uiState.facets && uiState.facets[facet] && (uiState.facets[facet].indexOf(key) > -1 || (split.length > 2 && uiState.facets[facet].indexOf(split[2]) > -1)); // uiState.facets[facet].indexOf(key) > -1;

                    const google_info = suggestion.google_info,
                        attr = { classes, google_info, onClick, tag, onRemove, isSelected, facet, key, className, getTagDisplayValue }

                    return <FacetChip key={i} props={{ ...attr }} isTypeAhead={true} />
                }
            }
            renderInputComponent={inputProps => {
                return <div>
                    <CustomInput
                        labelText={`Search ${facet === "pop_groups" ? "population groups" : facet}`}
                        color="info"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            ...inputProps,
                            color: 'info',
                            className: classes.input + ' info',
                            endAdornment: (<InputAdornment position="end">{progressBar}</InputAdornment>)
                        }}
                    />
                    {noData}
                </div>
            }}
            theme={autoCompleteStyles}
            renderSuggestionsContainer={renderSuggestionsContainer}
            inputProps={{ ...otherProps, onChange: handleOnChange }}
            onSuggestionSelected={(e, { suggestion }) => { addTag(suggestion.name) }}
            onSuggestionsClearRequested={() => { }}
            onSuggestionsFetchRequested={() => { }}
        />
    }
}

FacetAutosuggest.propTypes = {
    classes: PropTypes.object,
    props: PropTypes.object
}

export default withStyles(styles)(FacetAutosuggest);



// WEBPACK FOOTER //
// ./src/components/Article/common/FacetAutosuggest.jsx